<template>
  <div>
    <!--start not-found component-->
    <not-found-component />
    <!--snd not-found component-->
  </div>
</template>

<script>
//import components
import NotFoundComponent from "@/components/NotFound/NotFoundComponent.vue";

export default {
  name: "NotFound",

  components: { NotFoundComponent },
};
</script>
